class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {

    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

}

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // hide out of stock color-size swatches
        if (url.includes("main-collection")) {
          hideOOSColorSwatchFilteredSize();
          showNoResultsIfAllHidden(); 
        }
        FacetFiltersForm.renderProductCount(html);
        window.refreshCollectionColorFacets?.(html);
        
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // hide out of stock color-size swatches
    if (FacetFiltersForm.filterData.find(filterDataUrl).url.includes("main-collection")) {
      hideOOSColorSwatchFilteredSize();
      showNoResultsIfAllHidden(); 
    }
    FacetFiltersForm.renderProductCount(html);
    window.refreshCollectionColorFacets?.(html);
  }
  
    static scrollToProductsContainer() {
    const section = document.querySelector('.products-container');
    if (!section) return;
    const testVersionB = document.querySelector('.PLP-test-B');
    const isDesktop = window.innerWidth > 768;
    if (typeof testVersionB !== 'undefined' && testVersionB && isDesktop) {
      return;
    }

    const rect = section.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offsetTop = rect.top + scrollTop;

    const extraOffset = window.innerWidth <= 768 ? 170 : 100;

    window.scrollTo({
      top: offsetTop - extraOffset,
      behavior: 'smooth'
    });
  }


  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    productCardColorUpdateFunction();
    productCardColorSwatchesScroll();
    window.syncCollectionShadeProductCards?.(document, { hideWhileSync: true });
    checkActiveFacetsMobile();
    initProductCardVideos();
    FacetFiltersForm.scrollToProductsContainer();
    sortProductCards();
    scheduleCollectionAdLayout(50);
      // hide OOS + show empty message if all hidden
  if (
    document.getElementById('product-grid')
  ) {
    hideOOSColorSwatchFilteredSize();
    window.syncCollectionShadeExcludedProductCards?.(document);
    showNoResultsIfAllHidden();
    refreshCollectionProductCountDisplay();
  }
  }

  static renderProductCount(html) {
    const baseCount = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCount')
      .innerHTML;

    refreshCollectionProductCountDisplay(baseCount);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, .mobile-facets__wrapper #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelectorAll(`.js-filter[data-index="${element.dataset.index}"]`).forEach(el => {
        el.innerHTML = element.innerHTML;
      });
    });
    // Sync all checkbox states from the freshly-fetched HTML (authoritative source)
    const newChecked = new Set();
    parsedHTML.querySelectorAll('.js-filter input[type="checkbox"]:checked').forEach(input => {
      newChecked.add(`${input.name}|${input.value}`);
    });
    document.querySelectorAll('.js-filter input[type="checkbox"]').forEach(input => {
      input.checked = newChecked.has(`${input.name}|${input.value}`);
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.mobile-facets__wrapper--A .active-facets-mobile', '.mobile-facets__wrapper--B .active-facets-mobile', '.active-facets-desktop', '.active-facets-desktop-A'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
  
    if (!formData.get('filter.v.price.gte')) searchParams.delete('filter.v.price.gte');
    if (!formData.get('filter.v.price.lte')) searchParams.delete('filter.v.price.lte');
  
    return searchParams.toString();
  }
  

  onSubmitForm(searchParams, event) {
    let searchParamsUpdated = preserveCollectionShadeParams(searchParams);
    FacetFiltersForm.renderPage(searchParamsUpdated, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const triggerFormId = event.target.closest('form').id;
      const isMobile = triggerFormId === 'FacetFiltersFormMobile';

      // For sort-only forms (FacetSortForm / standalone mobile sort select),
      // preserve all active filter params from the current URL and only swap sort_by.
      // This is more reliable than reading filter state from form checkboxes.
      if (triggerFormId === 'FacetSortForm' || (isMobile && triggerFormId === 'FacetFiltersFormMobile' && event.target.name === 'sort_by')) {
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set('sort_by', event.target.value);
        this.onSubmitForm(currentParams.toString(), event);
        return;
      }

      const forms = [];
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(preserveCollectionShadeParams(url));
  }


}

const getHiddenProductCardsCount = function() {
  const grid = document.getElementById('product-grid');
  if (!grid) return 0;

  return Array.from(grid.querySelectorAll('.product-card')).filter((card) => {
    return window.getComputedStyle(card).display === 'none';
  }).length;
};

const refreshCollectionProductCountDisplay = function(baseCountHtml) {
  showNoResultsIfAllHidden();
  const container = document.getElementById('ProductCount');
  const containerDesktop = document.getElementById('ProductCountDesktop');
  const containerDesktopFilters = document.getElementById('ProductCountDesktopFilters');
  const baseCount =
    typeof baseCountHtml === 'string'
      ? baseCountHtml
      : container?.dataset.baseCountHtml || container?.innerHTML || '';

  if (!baseCount) return;

  [container, containerDesktop, containerDesktopFilters].forEach((element) => {
    if (!element) return;
    element.dataset.baseCountHtml = baseCount;
  });

  const hiddenProductsCount = getHiddenProductCardsCount();
  let count = baseCount;

  if (hiddenProductsCount > 0) {
    const match = count.match(/\d+/);

    if (match) {
      const productsCount = Math.max(parseInt(match[0], 10) - hiddenProductsCount, 0);
      count = count.replace(/\d+/, productsCount);
    }
  }

  if (container) {
    container.innerHTML = count;
    container.classList.remove('loading');
  }

  if (containerDesktop) {
    containerDesktop.innerHTML = count;
    containerDesktop.classList.remove('loading');
  }

  if (containerDesktopFilters) {
    containerDesktopFilters.innerHTML = count;
    containerDesktopFilters.classList.remove('loading');
  }
};

window.refreshCollectionProductCountDisplay = refreshCollectionProductCountDisplay;

const preserveCollectionShadeParams = function(searchParams) {
  const nextParams = new URLSearchParams(searchParams);
  const currentParams = new URLSearchParams(window.location.search);

  ['exclude-product-handle', 'exclude-product-id'].forEach((paramName) => {
    if (nextParams.has(paramName) || !currentParams.has(paramName)) return;
    nextParams.set(paramName, currentParams.get(paramName));
  });

  return nextParams.toString();
};

const showNoResultsIfAllHidden = function() {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const existing = grid.querySelector('.oos-no-results');
  const filteredSizes = new URLSearchParams(window.location.search).getAll('filter.v.option.size');
  const allCards = Array.from(grid.querySelectorAll('.product-card'));
  const allHidden = allCards.every(card => window.getComputedStyle(card).display === 'none');
  if (grid.closest('.main-collection')) grid.classList.toggle('collection--empty', allHidden);
  if (!allHidden) {
    existing?.remove();
    return;
  }
  // Shopify supplies its own message for a genuinely empty server result.
  // Add one when client-side availability hides the remaining cards instead.
  if (existing || (!allCards.length && !grid.querySelector('.collection-ad, .collection-promo'))) return;

  const msg = document.createElement('div');
  msg.className = 'oos-no-results';
  const text = document.createElement('p');
  text.textContent = filteredSizes.length
    ? `Sorry, no products are available in size ${filteredSizes.join(', ')} with the selected filters.`
    : 'Sorry, there are no products that match the filters.';
  const clear = document.createElement('a');
  clear.href = window.location.pathname;
  clear.textContent = 'Clear all filters';
  msg.append(text, clear);
  grid.appendChild(msg);
};

const hideOOSColorSwatchFilteredSize = function() {
  if (window.syncCollectionSizeFilteredCards && document.querySelector('.main-collection')) {
    window.syncCollectionSizeFilteredCards();
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const filteredSizes = params.getAll('filter.v.option.size');
  
  document.querySelectorAll('.product-card').forEach((productCard) => {
    productCard.style.display = productCard.dataset.collectionShadeExcluded === 'true' ? 'none' : '';
  });
  document.querySelectorAll('.color-swatch.size-hidden').forEach(s => s.classList.remove('size-hidden'));

  if (filteredSizes.length === 0) return;

  const renderedProducts = document.querySelectorAll('.product-card');
  renderedProducts.forEach(product => {
    let oosVariants = product.dataset.oosVariants;
    if (!oosVariants) return;

    oosVariants = oosVariants.split(" ,").map(str => str.trim()).filter(Boolean);

    const oosColors = new Set();
    oosVariants.forEach(variant => {
      const parts = variant.split(" / ").map(s => s.trim());
      const color = parts[0];
      const size = parts[1];
      if (filteredSizes.includes(size)) {
        oosColors.add(color.toLowerCase());
      }
    });

    oosColors.forEach(color => {
      const swatchEl = product.querySelector(`.color-swatch[data-color="${color}"]`);
      if (swatchEl) swatchEl.classList.add("size-hidden");
    });

    const allSwatches = product.querySelectorAll('.color-swatch');
    if (allSwatches.length === 0) return;

    const allHidden = Array.from(allSwatches).every(s => s.classList.contains('size-hidden'));
    if (allHidden) {
      product.style.display = 'none';
    }
  });
};
hideOOSColorSwatchFilteredSize();
window.syncCollectionShadeExcludedProductCards?.(document);
showNoResultsIfAllHidden();
refreshCollectionProductCountDisplay();




FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

const checkActiveFacetsMobile = function() {
  const activeFacetsMobile = document.querySelectorAll('.active-facets-mobile');
  if (activeFacetsMobile.length === 0) return;
  activeFacetsMobile.forEach(item => {
    const activeFacetsMobileContent = item.querySelector('.active-facets-mobile__body');
    if (activeFacetsMobileContent.textContent) item.classList.remove('hidden');
    else item.classList.add('hidden');
  });
}

checkActiveFacetsMobile();

function getMaxProductCardHeight(items) {
  const heights = items
    .filter((item) => item.classList.contains("product-card"))
    .map((item) => Math.ceil(item.getBoundingClientRect().height))
    .filter((height) => height > 0);

  return heights.length ? Math.max(...heights) : 0;
}

function syncCollectionAdHeights(grid) {
  const ads = Array.from(grid.querySelectorAll(".collection-ad"));
  if (!ads.length) return;

  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const columnCount = window.matchMedia("(max-width: 989px)").matches ? 2 : 4;
  const visibleChildren = Array.from(grid.children).filter(
    (item) => window.getComputedStyle(item).display !== "none"
  );

  ads.forEach((ad) => {
    const image = ad.querySelector(".collection-ad__image");
    if (!image) return;

    image.style.removeProperty("padding-bottom");
    image.style.removeProperty("height");

    if (isMobile) return;

    const hasCustomDesktopHeight =
      ad.style.getPropertyValue("--collection-ad-desktop-height").trim() !== "";

    if (hasCustomDesktopHeight) return;

    const adIndex = visibleChildren.indexOf(ad);
    if (adIndex === -1) return;

    const rowStart = Math.floor(adIndex / columnCount) * columnCount;
    let referenceHeight = getMaxProductCardHeight(
      visibleChildren.slice(rowStart, rowStart + columnCount)
    );

    if (!referenceHeight) {
      for (
        let previousRowStart = rowStart - columnCount;
        previousRowStart >= 0 && !referenceHeight;
        previousRowStart -= columnCount
      ) {
        referenceHeight = getMaxProductCardHeight(
          visibleChildren.slice(previousRowStart, previousRowStart + columnCount)
        );
      }
    }

    if (!referenceHeight) {
      referenceHeight = getMaxProductCardHeight(visibleChildren);
    }

    if (!referenceHeight) return;

    image.style.paddingBottom = "0";
    image.style.height = `${referenceHeight}px`;
  });
}

function moveCollectionAdFixed() {
  const grid = document.querySelector("#product-grid");
  if (!grid) return;

  const ads = Array.from(grid.querySelectorAll(".collection-ad"));
  if (!ads.length) return;

  const items = Array.from(grid.children).filter(
    (el) => !el.classList.contains("collection-ad")
  );
  const visibleItems = items.filter(
    (el) => window.getComputedStyle(el).display !== "none"
  );
  if (!visibleItems.length) return;

  // Only do the expensive remove/re-insert if an ad is currently being hovered
  const anyAdHovered = ads.some((ad) => ad.matches(":hover"));
  if (anyAdHovered) {
    syncCollectionAdHeights(grid);
    return;
  }

  ads.forEach((ad) => ad.remove());

  const fallbackPosition = parseInt(grid.dataset.collectionAdPosition || "0", 10);
  const sortableAds = [];
  const trailingAds = [];

  ads.forEach((ad, index) => {
    const requestedPosition = parseInt(
      ad.dataset.collectionAdPosition || `${fallbackPosition}`,
      10
    );

    if (Number.isNaN(requestedPosition) || requestedPosition < 1) {
      trailingAds.push({ ad, index });
      return;
    }

    sortableAds.push({ ad, index, requestedPosition });
  });

  sortableAds.sort((left, right) => {
    if (left.requestedPosition !== right.requestedPosition) {
      return left.requestedPosition - right.requestedPosition;
    }

    return left.index - right.index;
  });

  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  let insertedAds = 0;
  let lastResolvedPosition = 0;

  sortableAds.forEach(({ ad, requestedPosition }) => {
    const resolvedPosition = Math.max(requestedPosition, lastResolvedPosition + 1);
    let insertPosition = Math.max(resolvedPosition - 1 - insertedAds, 0);
    const isMobileProductCard = ad.classList.contains("collection-ad--mobile-product-card");

    if (isMobile && !isMobileProductCard) {
      const mobileColumns = 2;
      insertPosition = Math.floor(insertPosition / mobileColumns) * mobileColumns;
    }

    if (visibleItems[insertPosition]) {
      grid.insertBefore(ad, visibleItems[insertPosition]);
    } else {
      grid.appendChild(ad);
    }

    insertedAds++;
    lastResolvedPosition = resolvedPosition;
  });

  trailingAds.forEach(({ ad }) => {
    grid.appendChild(ad);
  });

  syncCollectionAdHeights(grid);
}

let collectionAdLayoutTimer;
let collectionAdCardsObserver;
let observedCollectionAdCards = [];

function observeCollectionAdDependencies() {
  if (typeof ResizeObserver === "undefined") return;

  const grid = document.getElementById("product-grid");
  if (!grid) return;

  if (!collectionAdCardsObserver) {
    collectionAdCardsObserver = new ResizeObserver((entries) => {
      const productCardChanged = entries.some((entry) => {
        if (!entry.target.classList.contains("product-card")) return false;
        // Ignore sub-pixel changes caused by hover scale animation reflows
        const rect = entry.contentRect;
        const prev = entry.target._collectionAdObservedSize;
        if (prev && Math.abs(rect.height - prev.height) < 1 && Math.abs(rect.width - prev.width) < 1) return false;
        entry.target._collectionAdObservedSize = { width: rect.width, height: rect.height };
        return true;
      });

      if (productCardChanged) {
        scheduleCollectionAdLayout(60);
      }
    });
  }

  observedCollectionAdCards.forEach((card) => {
    collectionAdCardsObserver.unobserve(card);
  });

  observedCollectionAdCards = Array.from(grid.querySelectorAll(".product-card"));
  observedCollectionAdCards.forEach((card) => {
    collectionAdCardsObserver.observe(card);
  });
}

function scheduleCollectionAdLayout(delay = 50) {
  clearTimeout(collectionAdLayoutTimer);
  collectionAdLayoutTimer = setTimeout(() => {
    moveCollectionAdFixed();
    observeCollectionAdDependencies();
  }, delay);
}

window.scheduleCollectionAdLayout = scheduleCollectionAdLayout;

function syncSortByNewColorsPlpClass() {
  const sortBy = new URLSearchParams(window.location.search).get('sort_by');
  const isNewColorsSort = sortBy === 'new-colors';

  document.querySelectorAll('.main-collection, .main-search').forEach((el) => {
    el.classList.toggle('sort-by-new-colors', isNewColorsSort);
  });

  window.syncNewestColorProductCards?.(document);
}

function sortProductCards(options = {}) {
  const { animate = true } = options;
  const params = new URLSearchParams(window.location.search);
  const sortBy = params.get('sort_by');
  const isPriceSort = sortBy === 'price-ascending' || sortBy === 'price-descending';
  const isNewColorsSort = sortBy === 'new-colors';

  syncSortByNewColorsPlpClass();

  if (!isPriceSort && !isNewColorsSort) return;

  const grid = document.getElementById('product-grid');
  if (!grid) return;

  const ascending = sortBy === 'price-ascending';
  const children = Array.from(grid.children);

  // Build a map of non-card elements: { slotIndex (among cards before it) -> element }
  const nonCardSlots = [];
  let cardCount = 0;
  children.forEach(el => {
    if (el.classList.contains('product-card') && el.dataset.price !== undefined) {
      cardCount++;
    } else {
      nonCardSlots.push({ afterCardIndex: cardCount, el });
    }
  });

  const cards = children.filter(el => el.classList.contains('product-card') && el.dataset.price !== undefined);
  if (cards.length < 2) {
    if (isNewColorsSort) {
      window.syncNewestColorProductCards?.(grid);
    }
    return;
  }

  const sortedCards = [...cards].sort((a, b) => {
    if (isNewColorsSort) {
      const countA = Number(a.dataset.newColorsCount ?? 0);
      const countB = Number(b.dataset.newColorsCount ?? 0);

      if (countA !== countB) return countB - countA;
      return 0;
    }

    const priceA = Number(a.dataset.price);
    const priceB = Number(b.dataset.price);
    if (Number.isNaN(priceA) || Number.isNaN(priceB)) return 0;
    return ascending ? priceA - priceB : priceB - priceA;
  });

  const orderChanged = sortedCards.some((card, index) => card !== cards[index]);
  if (!orderChanged) {
    if (isNewColorsSort) {
      window.syncNewestColorProductCards?.(grid);
    }
    return;
  }

  if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    rebuildSortedProductGrid(grid, sortedCards, nonCardSlots);
    return;
  }

  fadeReorderProductGrid(grid, sortedCards, nonCardSlots);
}

function rebuildSortedProductGrid(grid, sortedCards, nonCardSlots) {
  const fragment = document.createDocumentFragment();
  let inserted = 0;

  sortedCards.forEach(card => {
    nonCardSlots
      .filter(s => s.afterCardIndex === inserted)
      .forEach(s => fragment.appendChild(s.el));
    fragment.appendChild(card);
    inserted++;
  });

  nonCardSlots
    .filter(s => s.afterCardIndex >= inserted)
    .forEach(s => fragment.appendChild(s.el));

  grid.replaceChildren(fragment);
  window.syncNewestColorProductCards?.(grid);
}

function fadeReorderProductGrid(grid, sortedCards, nonCardSlots) {
  const state = grid._productSortFadeState || { animating: false, pending: false };
  grid._productSortFadeState = state;

  if (state.animating) {
    state.pending = true;
    return;
  }

  state.animating = true;
  state.pending = false;

  const finishAnimation = () => {
    const onFadeInEnd = (event) => {
      if (event.target !== grid || event.propertyName !== 'opacity') return;

      grid.style.transition = '';
      grid.style.opacity = '';
      grid.style.pointerEvents = '';
      grid.style.willChange = '';

      state.animating = false;

      if (state.pending) {
        state.pending = false;
        sortProductCards();
      }
    };

    grid.addEventListener('transitionend', onFadeInEnd, { once: true });

    window.requestAnimationFrame(() => {
      grid.style.opacity = '1';
    });
  };

  const onFadeOutEnd = (event) => {
    if (event.target !== grid || event.propertyName !== 'opacity') return;

    rebuildSortedProductGrid(grid, sortedCards, nonCardSlots);
    finishAnimation();
  };

  grid.style.transition = 'opacity 140ms ease';
  grid.style.opacity = '1';
  grid.style.pointerEvents = 'none';
  grid.style.willChange = 'opacity';
  grid.addEventListener('transitionend', onFadeOutEnd, { once: true });

  window.requestAnimationFrame(() => {
    grid.style.opacity = '0';
  });
}

window.sortProductCards = sortProductCards;
window.sortProductCardsByPrice = sortProductCards;
sortProductCards({ animate: false });
let collectionAdResizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(collectionAdResizeTimer);
  collectionAdResizeTimer = setTimeout(() => {
    scheduleCollectionAdLayout(0);
  }, 100);
});

window.addEventListener("load", () => {
  scheduleCollectionAdLayout(0);
});

scheduleCollectionAdLayout(50);
